import { useState } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { ArrowIcon } from '../Statement';

const Content = () => {
    const { t } = useLang('rule');
    const [activeIndex, setActiveIndex] = useState<number | null>(null);

    const list = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1785146636998/1.png',
            title: t('International_list_title1'),
            desc: t('International_list_desc1'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1785146636998/1.png',
            title: t('International_list_title2'),
            desc: t('International_list_desc2'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1785146645012/2.png',
            title: t('International_list_title3'),
            desc: t('International_list_desc3'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1785146636998/1.png',
            title: t('International_list_title4'),
            desc: t('International_list_desc4'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1785146636998/1.png',
            title: t('International_list_title5'),
            desc: t('International_list_desc5'),
        },
    ];
    const list2 = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1785146679659/4.png',
            title: t('International_region_title1'),
            desc: t('International_region_desc1'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1785146673538/3.png',
            title: t('International_region_title2'),
            desc: t('International_region_desc2'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1785146673538/3.png',
            title: t('International_region_title3'),
            desc: t('International_region_desc3'),
        },
        {
            img: '',
            title: t('International_region_title4'),
            desc: t('International_region_desc4'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1785146699914/7.png',
            title: t('International_region_title5'),
            desc: t('International_region_desc5'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1785146686268/5.png',
            title: t('International_region_title6'),
            linkText: 'PSTI Statement',
            link: 'https://www.ecoflow.com/uk/psti-related',
            desc: t('International_region_desc6'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1785146693194/6.png',
            title: t('International_region_title7'),
            desc: t('International_region_desc7'),
        },
    ];

    const handleToggle = (index: number) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className={styles.content}>
            <div className="title">{t('International_title')}</div>
            <div className="list">
                {list.map((item, index) => {
                    const isOpen = activeIndex === index;
                    return (
                        <div className={`item${isOpen ? ' open' : ''}`} key={index}>
                            <button type="button" className="item-header" onClick={() => handleToggle(index)} aria-expanded={isOpen}>
                                <span className="item-title">{item.title}</span>
                                <span className={`item-arrow${isOpen ? ' open' : ''}`} aria-hidden>
                                    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 10L8 6L12 10" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                            </button>
                            {isOpen && (
                                <div className="item-panel">
                                    <div className="item-desc">{item.desc}</div>
                                    {item.img && (
                                        <div className="item-logo">
                                            <img src={item.img} alt={item.title} draggable={false} />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
            <div className="title">{t('International_region_title')}</div>
            <div className="list">
                {list2.map((item, index) => {
                    const itemIndex = list.length + index;
                    const isOpen = activeIndex === itemIndex;
                    return (
                        <div className={`item${isOpen ? ' open' : ''}`} key={itemIndex}>
                            <button type="button" className="item-header" onClick={() => handleToggle(itemIndex)} aria-expanded={isOpen}>
                                <span className="item-title">{item.title}</span>
                                <span className={`item-arrow${isOpen ? ' open' : ''}`} aria-hidden>
                                    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 10L8 6L12 10" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                            </button>
                            {isOpen && (
                                <div className="item-panel">
                                    <div className="item-desc">{item.desc}</div>
                                    {item.linkText && (
                                        <div className="item-link">
                                            <a href={item.link} target="_blank" rel="noopener noreferrer">
                                                {item.linkText}
                                                <ArrowIcon color="#3f68e0" />
                                            </a>
                                        </div>
                                    )}
                                    {item.img && (
                                        <div className="item-logo">
                                            <img src={item.img} alt={item.title} draggable={false} />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Content;
